import { common } from "@shared/constants";
import { DataProvider, SeatingMapItemType } from "@shared/constants/common";
import { SeatingEventPropertyMap } from "@shared/modules/seating/types/seating-property-types";
import { useStore } from "@shared/store/useStore";
import isEmpty from "lodash/isEmpty";

/**
 * Returns the quantity of waitlisted seats in the cart.
 * This ONLY includes the waitlisted seats that are from the currently-displayed map.
 * If items from multiple maps are in the cart, only the current map's items are counted.
 *
 * IMPORTANT: This function can't be moved to useSeatingWaitlistHelpers.
 * getTotalWaitlistedSeatQty is called by useSeatingState and useSeatingState is also called by useSeatingWaitlistHelpers.
 * Moving this to useSeatingWaitlistHelpers would cause an import cycle.
 */
export function getTotalWaitlistedSeatQty(
  basketType: DataProvider,
  mapItemType: SeatingMapItemType,
  seatingEventData?: SeatingEventPropertyMap
) {
  const refreshedBasket = useStore.getState().getBasket(basketType);
  const itemGroups = refreshedBasket?.item_groups ?? [];

  if (!itemGroups || !itemGroups.length) {
    return 0;
  }

  // get all seating item groups that are waitlisted
  const waitlistItemGroups = itemGroups.filter((ig) => {
    // only check for items on the currently-displayed map
    const isSeatingMapVisible =
      (ig.event === seatingEventData?.id &&
        mapItemType === common.SeatingMapItemType.EVENT) ||
      (ig.membership_group === seatingEventData?.id &&
        mapItemType === common.SeatingMapItemType.MEMBERSHIP);

    return (
      !ig.parent &&
      isSeatingMapVisible &&
      isEmpty(ig.tt_seat_permissions) &&
      isEmpty(ig.tt_location_permissions) &&
      !isEmpty(ig.waitlist_seat_segment)
    );
  });

  return waitlistItemGroups.reduce(
    (acc: number, curr) => acc + (curr?.quantity || 0),
    0
  );
}
